import React from "react";
import Abs from "./Abs";

/**
 * Eyebrow + display title for the fixed-composition pages, placed at the template's own
 * coordinates (eyebrow baseline y=27, title y=41).
 */
export default function PageHeading({eyebrow, title, titleAccent, x = 48, y = 27, onDark}) {
    return (
        <Abs x={x} y={y}>
            {eyebrow ? (
                <div
                    className='bov-page__eyebrow'
                    style={onDark ? {color: '#fff', fontSize: '14px', letterSpacing: '1px'} : null}
                >
                    {eyebrow}
                </div>
            ) : null}
            {title || titleAccent ? (
                <h1 className='bov-page__title' style={onDark ? {color: '#fff'} : null}>
                    {title}
                    {titleAccent ? <em>{titleAccent}</em> : null}
                </h1>
            ) : null}
        </Abs>
    );
}
